import { signal } from '@angular/core';

export const recentHotCallsSignal = signal<any[]>([]);